import React from 'react';
import '../template-file-css/document-file-template.css';


export const CS_InterviewQuestions = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='CS_InterviewQuestions' className='file-pdf-document'>
            <div className='file-template'>


                <h3>
                    Body Language and Tips
                </h3>
                <p className='w-750'>
                    <strong>Directions:</strong> The following movements are examples of body language. Check all the examples of body language that one should display during a job interview.
                </p>
                <table>
                    <tr>
                        <td className='w-20'>
                            <input type="checkbox" name="chkDirections_1" id="chkDirections_1" className='add-only' value="Directions_1" />
                        </td>
                        <td className='w-730'>
                            Arrive 10-15 minutes early for your interview
                        </td>
                    </tr>
                    <tr>
                        <td className='w-20'>
                            <input type="checkbox" name="chkDirections_2" id="chkDirections_2" className='add-only' value="Directions_2" />
                        </td>
                        <td className='w-730'>
                            Take a 1-2 copies of your resume with you to the interview
                        </td>
                    </tr>
                    <tr>
                        <td className='w-20'>
                            <input type="checkbox" name="chkDirections_3" id="chkDirections_3" className='add-only' value="Directions_3" />
                        </td>
                        <td className='w-730'>
                            Take a black or blue pen to the interview with you
                        </td>
                    </tr>
                    <tr>
                        <td className='w-20'>
                            <input type="checkbox" name="chkDirections_4" id="chkDirections_4" className='add-only' value="Directions_4" />
                        </td>
                        <td className='w-730'>
                            Take your ID and your Social Security Card to the interview in case you are hired on the spot
                        </td>
                    </tr>
                    <tr>
                        <td className='w-20'>
                            <input type="checkbox" name="chkDirections_5" id="chkDirections_5" className='add-only' value="Directions_5" />
                        </td>
                        <td className='w-730'>
                            Silence your phone or leave it in the car
                        </td>
                    </tr>
                    <tr>
                        <td className='w-20'>
                            <input type="checkbox" name="chkDirections_6" id="chkDirections_6" className='add-only' value="Directions_6" />
                        </td>
                        <td className='w-730'>
                            Do not take a back pack in the interview with you if possible
                        </td>
                    </tr>
                    <tr>
                        <td className='w-20'>
                            <input type="checkbox" name="chkDirections_7" id="chkDirections_7" className='add-only' value="Directions_7" />
                        </td>
                        <td className='w-730'>
                            Do not go to interview with friends or children
                        </td>
                    </tr>
                    <tr>
                        <td className='w-20'>
                            <input type="checkbox" name="chkDirections_8" id="chkDirections_8" className='add-only' value="Directions_8" />
                        </td>
                        <td className='w-730'>
                            Remove your coat once inside the place where you will interview
                        </td>
                    </tr>
                    <tr>
                        <td className='w-20'>
                            <input type="checkbox" name="chkDirections_9" id="chkDirections_9" className='add-only' value="Directions_9" />
                        </td>
                        <td className='w-730'>
                            Smile
                        </td>
                    </tr>
                    <tr>
                        <td className='w-20'>
                            <input type="checkbox" name="chkDirections_10" id="chkDirections_10" className='add-only' value="Directions_10" />
                        </td>
                        <td className='w-730'>
                            Speak Loud Enough to be Heard
                        </td>
                    </tr>
                    <tr>
                        <td className='w-20'>
                            <input type="checkbox" name="chkDirections_11" id="chkDirections_11" className='add-only' value="Directions_11" />
                        </td>
                        <td className='w-730'>
                            Keep Your Answers Not too short and Not to Long - Avoid saying yes or no, instead, Elaborate
                        </td>
                    </tr>
                    <tr>
                        <td className='w-20'>
                            <input type="checkbox" name="chkDirections_12" id="chkDirections_12" className='add-only' value="Directions_12" />
                        </td>
                        <td className='w-730'>
                            Wait to be Offered a Seat When Entering the Interview Room if not offered, Ask "may I sit Here?"
                        </td>
                    </tr>
                    <tr>
                        <td className='w-20'>
                            <input type="checkbox" name="chkDirections_13" id="chkDirections_13" className='add-only' value="Directions_13" />
                        </td>
                        <td className='w-730'>
                            Do Not Fold Arms
                        </td>
                    </tr>
                    <tr>
                        <td className='w-20'>
                            <input type="checkbox" name="chkDirections_14" id="chkDirections_14" className='add-only' value="Directions_14" />
                        </td>
                        <td className='w-730'>
                            Keep Good Eye Contact with Interviewer
                        </td>
                    </tr>
                    <tr>
                        <td className='w-20'>
                            <input type="checkbox" name="chkDirections_15" id="chkDirections_15" className='add-only' value="Directions_15" />
                        </td>
                        <td className='w-730'>
                            Remain Facing Interviewer
                        </td>
                    </tr>
                    <tr>
                        <td className='w-20'>
                            <input type="checkbox" name="chkDirections_16" id="chkDirections_16" className='add-only' value="Directions_16" />
                        </td>
                        <td className='w-730'>
                            Firm handshake
                        </td>
                    </tr>
                    <tr>
                        <td className='w-20'>
                            <input type="checkbox" name="chkDirections_17" id="chkDirections_17" className='add-only' value="Directions_17" />
                        </td>
                        <td className='w-730'>
                            Sit tall
                        </td>
                    </tr>
                    <tr>
                        <td className='w-20'>
                            <input type="checkbox" name="chkDirections_18" id="chkDirections_18" className='add-only' value="Directions_18" />
                        </td>
                        <td className='w-730'>
                            Ask 1 to 2 questions at the end of interview:
                            <ol>
                                <li>
                                    "What do you look for in your employees?"
                                </li>
                                <li>
                                    "When should I expect to hear something back?"
                                </li>
                            </ol>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-20'>
                            <input type="checkbox" name="chkDirections_19" id="chkDirections_19" className='add-only' value="Directions_19" />
                        </td>
                        <td className='w-730'>
                            Ask for a business card inorder to use interviewer's email to send thank you note later the same day, after the interview.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-20'>
                            <input type="checkbox" name="chkDirections_20" id="chkDirections_20" className='add-only' value="Directions_20" />
                        </td>
                        <td className='w-730'>
                            Don't forget to say thank you and have a nice day! at the end of the interview.
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <strong>Extras:</strong> Wear neutral conservative clothes with no writing, shower and do not wear perfumes or colognes, shave and wear conservative hair style, wear closed toe shoes and no jeans or sweat pants, take a copy of your resume and a black pen, take two forms of ID, arrive 10 to 15 minutes earlier, give yourself 1 hour travel time to get there.  You can map out parking arrangement, the bus route or rideshare cost the day before your interview.  Lastly, Practice interview questions aloud with a friend or family member the day before.  If no one is available, practice aloud in the mirror.
                    *Don't forget to get a business card when you leave the interview so you can send a thank you email/letter as soon as you get home.
                </p>
                <h4>
                    GOOD LUCK!
                </h4>
                <h3>
                    Sample Job Interview Questions
                </h3>
                <p className='w-750'>
                    <strong>Directions:</strong> Answer the following questions as you would answer them during an interview. Then look at the answer key to see how well you answered. Finally practice your corrected answers out loud with proper body language.
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>1.	Tell me about yourself.</span>
                    <textarea id="txtInterview_1" name="txtInterview_1" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>2.	What do you know about our company?</span>
                    <textarea id="txtInterview_2" name="txtInterview_2" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>3.	Why are you interested in working here?</span>
                    <textarea id="txtInterview_3" name="txtInterview_3" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>4.	What experience or training do you have for this position?</span>
                    <textarea id="txtInterview_4" name="txtInterview_4" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>5.	What are your strengths?</span>
                    <textarea id="txtInterview_5" name="txtInterview_5" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>6.	What are your weaknesses?</span>
                    <textarea id="txtInterview_6" name="txtInterview_6" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>7.	Why did you leave your last job?</span>
                    <textarea id="txtInterview_7" name="txtInterview_7" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>8.	How would you handle a conflict with a coworker?</span>
                    <textarea id="txtInterview_8" name="txtInterview_8" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>9.	How many hours per week are you looking to work? Are you willing to work weekends?</span>
                    <textarea id="txtInterview_9" name="txtInterview_9" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>10. Tell me a couple things that are most important to you about a job.</span>
                    <textarea id="txtInterview_10" name="txtInterview_10" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>11.	Tell me now you would handle an angry customer.</span>
                    <textarea id="txtInterview_11" name="txtInterview_11" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>12.	Tell me about an accomplishment you are most proud of.</span>
                    <textarea id="txtInterview_12" name="txtInterview_12" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>13.	Describe your best boss.</span>
                    <textarea id="txtInterview_13" name="txtInterview_13" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>14.	Describe your worst boss.</span>
                    <textarea id="txtInterview_14" name="txtInterview_14" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>15.	What is your definition of good customer service?</span>
                    <textarea id="txtInterview_15" name="txtInterview_15" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>16.	Where do you see yourself in a year?</span>
                    <textarea id="txtInterview_16" name="txtInterview_16" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>17.	Give me an example of time you showed leadership.</span>
                    <textarea id="txtInterview_17" name="txtInterview_17" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>18.	Describe a time you had to ask questions and listen carefully to clarify a customer's problem.</span>
                    <textarea id="txtInterview_18" name="txtInterview_18" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>19.	Tell me about a time when your job required high attention to detail.</span>
                    <textarea id="txtInterview_19" name="txtInterview_19" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>20.	Describe a work decision you have made that you wish you could do over.</span>
                    <textarea id="txtInterview_20" name="txtInterview_20" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>21.	Do you have questions for me?</span>
                    <textarea id="txtInterview_21" name="txtInterview_21" className='add-only'></textarea>
                </p>
                <h4>
                    Sample Job Interview Questions: Answer Key
                </h4>
                <ol>
                    <li>
                        You need to mention 2 or 3 skills and include a real-life example of them from a previous job.
                    </li>
                    <li>
                        Research the company and look for name of CEO, headquarters location, how long in business and company mission and slogan, main product or service sold, etc.
                    </li>
                    <li>
                        Make sure to research the company before the interview and give specific reasons.
                    </li>
                    <li>
                        Read the job description prior to the interview. Describe the skills you have that match the job.
                    </li>
                    <li>
                        Refer back to your completed "Strengths" worksheet to answer this question.
                    </li>
                    <li>
                        Be brief and general. Start by saying something positive, followed by what your weakness is. End your answer by stating what you are doing to correct that weakness and improve yourself.<br />
                        For example, am very ambitious, but sometimes I do so much it is hard to stay organized. However, I now keep a planner so all my tasks and goals are in order and get accomplished."
                    </li>
                    <li>
                        Prepare an answer that does not involve just quitting, such as you relocated, started school or training program, obtained employment in new area of interest, etc.  Do not bad mouth any employer, coworkers or bosses.
                    </li>
                    <li>
                        You may want to consider delaying your response to the conflict to allow your emotions to calm. Take co-worker aside and try to work it out and if you can't, take the situation to a manager.
                    </li>
                    <li>
                        Be as flexible as possible. Only express limits when absolutely necessary.
                    </li>
                    <li>
                        Friendly, team-oriented work environment.
                    </li>
                    <li>
                        Stay calm, listen carefully, and manage the situation with confidence and respect
                    </li>
                    <li>
                        The answer should be work-related and is an example of going above and beyond what was expected. When you are explaining the story, begin by describing the situation then describe what you personally did. End your answer by explaining what the end result was.
                    </li>
                    <li>
                        Do not use specific names. Instead, describe the positive traits of your best supervisor or your ideal supervisor. For example, you may want a boss who treats his employees fairly.
                    </li>
                    <li>
                        Do not say anything negative. Pick a work-related characteristic that can be stated in a positive way. For example, "l had a supervisor who was vague when giving assignments. I learned to ask questions so that I knew what was expected".
                    </li>
                    <li>
                        Greet each customer with a smile and ask if you can help with something. Thank the customer for their business and welcome them back by saying, hope to see you again soon, enjoy your day. (just an example)
                    </li>
                    <li>
                        The interviewer is checking on your maturity and whether you are someone who likes to grow and learn. Examples might include; learned my job well enough to teach others, looking forward to another year, getting a chance at advancement, etc.
                    </li>
                    <li>
                        Be specific. Describe the situation then your action followed by the outcome of your action.
                    </li>
                    <li>
                        Be specific. Describe the situation then describe your action followed by the outcome.
                    </li>
                    <li>
                        Think of a specific example that required accuracy, special skills, and failure to use these skills would have led to problems from your employer.
                    </li>
                    <li>
                        Be specific, but do not pick anything too negative. Begin by describing something positive you normally do. Then describe a time that you might have done the opposite. Finally, end by saying something positive by explaining what you learned from your mistake.
                    </li>
                    <li>
                        Always come prepared with at least two questions for the employer. Do not ask questions about salary or benefits. Ask questions such as, "How would you describe a typical day on the job?," "Will there be opportunities for advancement and ongoing trainings?" and "What kind of person are you looking for?" "When should I expect to hear back?"
                    </li>
                </ol>






            </div>
        </form>

    )
}